<div
  class="prompt-box relative p-2 flex min-h-16 justify-between bg-branding-800 max-lg:landscape:p-1 max-lg:landscape:min-h-12"
  [class]="biggerPrompt() ? 'rounded-2xl items-end' : 'rounded-[1000px] items-center small'"
  [class.justify-end]="noLeftButton()"
  [style.height]="promptBoxHeight() + 'px'"
>
  @if (displayPlusButton()) {
    <mib-button #plusButton theme="ai" size="large" shape="rounded-full" iconOnly>
      <svg mib-plus-icon></svg>
    </mib-button>
  } @else if (!hidePTT()) {
    <mib-button
      theme="ai"
      size="large"
      shape="rounded-full"
      iconOnly
      aria-label="Push to talk — hold to speak"
      [attr.aria-pressed]="isPttActive()"
      (pointerdown)="pttStart.emit()"
      (pointerup)="pttStop.emit()"
      (pointerleave)="pttStop.emit()"
      (keydown.space)="pttStart.emit(); $event.preventDefault()"
      (keyup.space)="pttStop.emit()"
    >
      @if (isPttActive()) {
        <svg mib-microphone-icon></svg>
      } @else {
        <svg mib-microphone-off-icon></svg>
      }
    </mib-button>
  }

  <div class="absolute flex transition-all ease-in-out duration-200" [class]="textareaPosition()">
    <div class="flex flex-col flex-1 justify-center" [class.hidden]="!isPttActive()">
      <p class="text-xs text-gray-500">Recording:</p>
      <p class="text-sm">{{ pttTranscription() }}</p>
    </div>
    <textarea
      #textarea
      class="w-full border-none outline-none resize-none pr-4 mib-scrollbar text-sm"
      [class.hidden]="isPttActive()"
      rows="1"
      name="prompt"
      id="prompt"
      [placeholder]="placeholder()"
      [formControl]="userPrompt"
      (input)="updatePromptHeight($event)"
      (keydown.enter)="$event.preventDefault()"
      (keyup.enter)="sendPrompt()"
    ></textarea>
  </div>

  <mib-button
    theme="ai"
    size="large"
    shape="rounded-full"
    iconOnly
    mibTooltip="Send"
    mibTooltipShowDelay="500"
    [disabled]="chatLocked()"
    (click)="sendPrompt()"
  >
    <svg mib-send-icon></svg>
  </mib-button>
</div>
